import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export const useCenterData = (centerSlug: string) => {
  return useQuery({
    queryKey: ['center', centerSlug],
    staleTime: 5 * 60 * 1000, // 5 minutes
    queryFn: async () => {
      const { data, error } = await supabase
        .from('schoolola_centers')
        .select('*')
        .eq('slug', centerSlug)
        .maybeSingle();

      if (error) {
        console.error('Error fetching center data:', error);
        throw error;
      }

      return data;
    },
    enabled: !!centerSlug,
  });
};